<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-data-table
              :headers="headers"
              :items="dataItems"
              :loading="loading"
              :search="search"
              class="elevation-1"
              item-key="_id"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>
                  Public Relations
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Public Relations"
                    single-line
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-model="addPR"
                        v-bind="attrs"
                        v-on="on"
                        class="mb-2"
                        color="primary"
                        dark
                        @click="addPR = true"
                    >
                      New Public Relations
                    </v-btn>
                  </template>

                  <!--
                    Alerts & Loaders
                  -->
                  <Loader :loading="loadingCreateUpdateDelete"/>
                  <!--<Alerts :aType.sync="response"/>-->

                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.pr_name"
                                  label="Name"
                                  @blur="$v.editedItem.pr_name.$touch()"
                              ></v-text-field>
                              <p v-if="$v.editedItem.pr_name.$model === '' && !$v.editedItem.pr_name.required"
                                 style="color: red;">Please provide a valid name.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.pr_shortcode"
                                  label="PR Shortcode"
                                  @blur="$v.editedItem.pr_shortcode.$touch()"
                              ></v-text-field>
                              <p v-if="$v.editedItem.pr_shortcode.$model === '' && !$v.editedItem.pr_shortcode.required"
                                 style="color: red;">Please provide a valid shortcode.</p>
                              <p v-if="!$v.editedItem.pr_shortcode.alphaNum" style="color: red;">No special characters
                                are
                                valid.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.pr_phone"
                                  label="Phone Number"
                                  @blur="$v.editedItem.pr_phone.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.pr_phone.check_phone" style="color: red;">Phone number must start
                                with
                                91,92,93 or 96.</p>
                              <p v-if="!$v.editedItem.pr_phone.numeric" style="color: red;">Phone number must a numeric
                                value.</p>
                              <p v-if="!$v.editedItem.pr_phone.minLength || !$v.editedItem.pr_phone.maxLength"
                                 style="color: red;">Phone number must have 9 digits.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.pr_email"
                                  label="Email"
                                  @blur="$v.editedItem.pr_email.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.pr_email.email || !$v.editedItem.pr_email.wbst_suffix"
                                 style="color: red;">Please provide a valid email address.</p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                          :disabled="$v.$invalid"
                          color="blue darken-1"
                          text
                          @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="550px">
                  <v-card>
                    <v-card-title class="headline">Are you sure you want to remove this PR?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                  <Loader :loading="loadingCreateUpdateDelete"/>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                  class="mr-2"
                  small
                  @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                  small
                  @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {manager_create_pr, manager_delete_pr, manager_get_all_prs, manager_update_pr} from "../../modules/nite_api";
import {required, email, helpers, minLength, maxLength, numeric, alphaNum} from 'vuelidate/lib/validators';
import Loader from "../shared/Loader"
import VueNotifications from "vue-notifications";

//Check if email contains .com or .net
const wbst_suffix = helpers.regex('alpha', /(\.com|\.net)$/);

//Check if the phone number start with 91,92,93,96 and has 9 elements
const check_phone = helpers.regex('numeric', /^(91|92|93|96)/);

export default {
  components: {
    Loader
  },
  data: () => ({
    response: null,
    loadingCreateUpdateDelete: false,
    loading: false,
    dialog: false,
    dialogDelete: false,
    addPR: false,
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'pr_fullname',
      },
      {text: 'PR Shortcode', value: 'pr_shortcode', sortable: true},
      {text: 'Phone Number', value: 'pr_phone', sortable: false},
      {text: 'Email', value: 'pr_email', sortable: false},
      {text: 'Actions', value: 'actions', sortable: false},
    ],
    dataItems: [],
    editedItem: {
      pr_name: '',
      pr_shortcode: '',
      pr_phone: '',
      pr_email: '',
      pr_id: ''

    },
    defaultItem: {
      pr_name: '',
      pr_shortcode: '',
      pr_phone: '',
      pr_email: '',
      pr_id: ''
    },
  }),
  validations: {
    editedItem: {
      pr_name: {
        required,
      },
      pr_shortcode: {
        required,
        alphaNum
      },
      pr_phone: {
        check_phone,
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      pr_email: {
        wbst_suffix,
        required,
        email
      }
    }
  },
  computed: {
    formTitle() {
      return this.addPR === true ? 'New PR' : 'Edit PR'
    },

  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },

  },

  created() {
    this.getDataFromApi()
  },

  methods: {

    async getDataFromApi() {

      this.loading = true
      try {

        const response = await manager_get_all_prs()
        // Success
        console.log(response);
        this.dataItems = response.data;

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error);
      } finally {

        this.loading = false
        switch (this.response) {
          case 200:
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }


    },


    editItem(item) {
      this.editedItem.pr_name = item.pr_fullname
      this.editedItem.pr_shortcode = item.pr_shortcode
      this.editedItem.pr_phone = item.pr_phone
      this.editedItem.pr_email = item.pr_email
      this.editedItem.pr_id = item._id
      this.dialog = true
    },

    deleteItem(item) {

      this.editedItem.pr_id = item._id
      this.dialogDelete = true
    },

    async deleteItemConfirm() {
      this.loadingCreateUpdateDelete = true;
      try {

        const response = await manager_delete_pr(this.editedItem.pr_id);


        // Success
        console.log(response);
        this.response = response.status;


      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'PR deleted successfully!'});
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 404:
            this.showErrorMsg({title: 'Oops', message: 'The PR doesn\'t exist! Please try again!'});
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }


      await this.closeDelete()

    },

    async close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
      this.addPR = false
      await this.getDataFromApi()
    },

    async closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
      await this.getDataFromApi()

    },

    async save() {
      let request_data = {
        "pr_fullname": this.editedItem.pr_name,
        "pr_shortcode": this.editedItem.pr_shortcode,
        "pr_phone": this.editedItem.pr_phone,
        "pr_email": this.editedItem.pr_email,
      }
      this.loadingCreateUpdateDelete = true;
      if (this.addPR) {

        try {

          const response = await manager_create_pr(request_data);


          // Success
          console.log(response);
          this.response = response.status;


        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'PR added successfully!'});
              break;

            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;
            case 404:
              this.showErrorMsg({title: 'Oops', message: 'The resource doesn\'t exist! Please try again!'});
              break;
            case 409:
              this.showErrorMsg({
                title: 'Oops',
                message: 'The PR that you trying to add already exists! Please try again!'
              });
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }


      } else {

        try {

          const response = await manager_update_pr(this.editedItem.pr_id, request_data);

          // Success
          console.log(response);
          this.response = response.status;

        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'PR edited successfully!'});
              break;
            case 304:
              this.showWarnMsg({title: 'Oops', message: 'You didn\'t update nothing!'});
              break;
            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;

            case 409:
              this.showErrorMsg({
                title: 'Oops',
                message: 'The PR that you trying to edit already exists! Please try again!'
              });
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }


      }


      await this.close()
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }
  }
}
</script>

<style>
</style>
